<template>
    <div class="form-group">
        <input v-model="email.address" type="text" class="form-control" :disabled="!isNew"/>
        <template v-if="userId">
            <template v-if="isNew"> 
                <button @click.prevent="saveEmail" :disabled="isPending">Save</button>
            </template>
            <template v-else-if="! isVerified">
                <button @click.prevent="verifyEmail" :disabled="isPending">Resend verification email</button>
            </template>
            <template v-else>
                <button @click.prevent="makePrimary" :disabled="isPending">Make primary email</button>
            </template>
        </template>
        <button @click.prevent="cancel" :disabled="isPending">{{isNew ? 'Cancel' : 'Remove'}}</button>
    </div>
</template>

<script>

import { User } from 'ca-api-client';

export default {
    name: 'AdditionalEmail',
    props: {
        value: Object,
        userId: String
    },
    data() {
        return {
            isPending: false,
        }
    },
    computed: {
        isNew() {
            return !this.email.id;
        },
        isVerified() {
            return this.email.verified;
        },
        email: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value)
            }
        },
    },
    methods: {
        async saveEmail() {
            this.isPending = true;
            let user = await User.$find(this.userId);
            try {
                user = await user.patch({
                    additional_emails: {
                        assign: [this.email.address]
                    }
                });

                user.additional_emails.forEach(email => {
                    if (email.address === this.email.address) {
                        this.email = email;
                        return;
                    }
                });
            } catch (e) {
                ca.confirm({
                    type: 'error',
                    title: 'This email is unavailable',
                    showConfirmButton: false,
                    cancelButtonText: '<i class="fas fa-times"></i> Close',
                    html: '<p>This email is already taken by another user.  If you believe this to be in error, please contact the Spatial Media team.</p>',
                });
            }
            this.isPending = false;
        },
        async verifyEmail() {
            let user = await User.$find(this.userId);
            user.verifyEmail(this.email.id);
        },
        async makePrimary() {
            this.isPending = true;
            let user = await User.$find(this.userId);
            let originalEmail = user.email;
            user = await user.patch({
                email: this.email.address
            });
            this.$emit('make-email-primary', this.email);
            user.additional_emails.forEach(email => {
                if (email.address === originalEmail) {
                    this.email = email;
                    return;
                }
            });
            this.isPending = false;
        },
        async cancel() {
            if (! this.isNew) {
                this.isPending = true;
                let user = await User.$find(this.userId);
                user = user.patch({
                    additional_emails: {
                        unassign: [this.email.address]
                    }
                });
                this.isPending = false;
            }

            this.$emit('cancel', this.email);
        }
    },
}
</script>
